import React, { Component } from "react";
import { Accessor, ColorX, ZMath, ZVector2D } from "../../../../STATIC";
import { VStack, XButton, XText } from "../../../../_X";
import PropsType from "prop-types";
import _ from "lodash";

/**
 * @augments {Component<Props, State>}
 */
class CyclePicker extends Component {

  static propTypes = {

    size: PropsType.oneOfType([PropsType.number, PropsType.string]), 

    selected: PropsType.string,
    selectOptions: PropsType.array,
    selectInnerOptions: PropsType.array,

    onSelect: PropsType.func,
    angleOffsetInterval: PropsType.number,

    outterSize: PropsType.number,
    outterDis: PropsType.number,
    innerSize: PropsType.number,
    innerDis: PropsType.number
  };

  static defaultProps = {
    size: 284,

    selected: null,
    selectOptions: [],
    selectInnerOptions: [],

    onSelect: null,
    angleOffsetInterval: 1,
  };

  constructor(props){
    super();
    let {size, selectOptions, selectInnerOptions} = props;
    let center = (size * 0.9) / 2;
    let interval = selectOptions.length > 0 ? (360 / selectOptions.length) : 0;
    let innerInterval = selectInnerOptions.length > 0 ? (360 / selectInnerOptions.length) : 0;
    
    this.state = {
      center: center,
      interval: interval,
      innerInterval: innerInterval,
      lastOption: null
    };
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(CyclePicker.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  shouldComponentUpdate(nextProps, nextState){
    let propIdentical = Accessor.IsIdentical(nextProps, this.props, Object.keys(CyclePicker.defaultProps));
    let stateIdentical = Accessor.IsIdentical(nextState, this.state, null);
    if(propIdentical && stateIdentical){
      return false;
    }
    return true;
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  };

  _getSize = () => {
    let {size} = this.props;
    return {
      outterSize: 24 * size / 284,
      outterDis: 105 * size / 284,
      innerSize: 20 * size / 284,
      innerDis: 75 * size / 284
    };
  }

  _onSelect = (option, dragging) => {
    let {onSelect} = this.props;
    this.setState({
      lastOption: option, 
    }, () => {
      onSelect?.(option, dragging);
    });
  };

  _onDragStart = (e) => {
    this.setState({
      dragging: true
    });
  };

  /**
   * 
   * @param {import("react").DragEvent} e 
   * @returns 
   */
  _onDragMove = (e) => {
    let {offsetX, offsetY} = e.nativeEvent;
    let {angleOffsetInterval, selectOptions, selectInnerOptions} = this.props;
    let {center, interval, innerInterval} = this.state;
    let {innerDis, outterDis} = this._getSize();

    let calDis = ZVector2D.Distance(
      {x: offsetX, y: offsetY}, 
      {x: center, y: center}
    );
    let calAngle = ZVector2D.Angle(
      {x: offsetX, y: offsetY}, 
      {x: center, y: center}
    );
    
    let inInner = ZMath.IsBetween(calDis, innerDis - 10, innerDis + 10);
    let inOutter = ZMath.IsBetween(calDis, outterDis - 10, outterDis + 10);

    if(!inInner && !inOutter) return;

    let getInterval = inInner ? innerInterval : interval;

    let idx = Math.round((calAngle + getInterval / 2) / getInterval) - angleOffsetInterval;
    let option = inInner ? 
      selectInnerOptions[idx % selectInnerOptions.length] 
      : selectOptions[idx % selectOptions.length];
    this._onSelect(option, true);
  };

  _onDragEnd = (e) => {
    let {lastOption} = this.state;
    this.setState({
      dragging: false
    }, () => {
      this._onSelect(lastOption, false);
    });
  };

  _onDragCancel = (e) => {
    this._onDragEnd();
  };

  renderBtn(option, key, degree, distance, size, center){
    let {selected} = this.props;
    let isTime = String(selected) === String(option);
    let bgColor = isTime ? ColorX.CSS("gambot2Blue") : ColorX.CSS("pureWhite", 0.7);
    let textColor = isTime ? ColorX.CSS("pureWhite") : ColorX.CSS("gambot2Blue"); 
    return (
      <XButton onPress={(e) => {
        e.stopPropagation();
        this._onSelect(option, false);
      }} key={key}
        style={{
          position: "absolute",
          top: center + distance * Math.sin(ZMath.Deg2Rad(degree - 90)) - size / 2,
          left: center + distance * Math.cos(ZMath.Deg2Rad(degree - 90)) - size / 2,
          width: size,
          height: size,
          alignItems: "center",
          justifyContent: "center",
          padding: 0,
          borderRadius: 50,
          backgroundColor: bgColor
        }}>
        <XText style={{fontSize: size * 0.7, color: textColor, fontFamily: "sans-serif"}}>
          {String(option)}
        </XText>
      </XButton>
    );
  }

  renderCenter(center, size){
    return (
      <VStack 
        style={{
          position: "absolute",
          top: center - size / 2,
          left: center - size / 2,
          width: size,
          height: size,
          alignItems: "center",
          justifyContent: "center",
          padding: 0,
          borderRadius: 50,
          backgroundColor: ColorX.CSS("gambot2Blue")
        }}/>
    );
  }

  renderPointer(center, interval, innerInterval){
    let {selected, selectOptions, selectInnerOptions, angleOffsetInterval} = this.props;
    let {outterDis, innerDis} = this._getSize();

    let idx = _.findIndex(selectOptions, o => String(o) === String(selected));
    let isOutter = true;
    if(idx < 0){
      idx = _.findIndex(selectInnerOptions, o => String(o) === String(selected));
      if(idx >= 0){
        isOutter = false;
      }
    }
    if(idx < 0) return;

    let dis = (isOutter ? outterDis : innerDis) * 0.95;
    let degree = (isOutter ? interval : innerInterval) * (idx + angleOffsetInterval) - 90;
    let h = 2;

    return (
      <VStack
        style={{
          position: "absolute",
          width: dis,
          height: h,
          backgroundColor: ColorX.CSS("gambot2Blue"),
          top: center,
          left: center,
          transform: `translateX(${-dis / 2}px) rotate(${degree}deg) translateX(${dis / 2}px)`
        }}/>
    );
  }

  renderHandler(){
    let {center, interval, innerInterval, dragging} = this.state;
    let {selected, selectOptions, selectInnerOptions, angleOffsetInterval} = this.props;
    let {innerDis, innerSize, outterDis, outterSize} = this._getSize();
    if(!selected) return;

    let isOutter = false;
    let idx = -1;

    idx = _.findIndex(selectOptions, o => String(o) === String(selected));
    if(idx >= 0) { isOutter = true; }
    else{
      idx = _.findIndex(selectInnerOptions, o => String(o) === String(selected));
    }

    idx = angleOffsetInterval + idx;

    let distance = isOutter ? outterDis : innerDis;
    let size = (isOutter ? outterSize : innerSize) + (dragging ? 10 : 0);
    let degree = idx * (isOutter ? interval : innerInterval);

    let top = center + distance * Math.sin(ZMath.Deg2Rad(degree - 90)) - size / 2;
    let left = center + distance * Math.cos(ZMath.Deg2Rad(degree - 90)) - size / 2;

    return (
      <VStack zIndex={-1}
        style={{
          position: "absolute",
          top: top, 
          left: left,
          width: size,
          height: size,
          alignItems: "center",
          justifyContent: "center",
          padding: 0,
          borderRadius: 50,
          backgroundColor: ColorX.CSS("gambot2Blue", 0.3)
        }}/>
    );
  }

  renderCore(){
    let {center, interval, innerInterval} = this.state;
    let {size, selectOptions, selectInnerOptions, angleOffsetInterval} = this.props;
    let {outterDis, outterSize, innerDis, innerSize} = this._getSize();
    return (
      <VStack style={{
        backgroundColor: ColorX.CSS("aliceblue"), 
        width: size * 0.9, height: size * 0.9, 
        borderRadius: 500,
        position: "relative"
      }}>
        {this.renderCenter(center, 6)}
        {this.renderPointer(center, interval, innerInterval)}
        {_.map(selectOptions, (o, i) => {
          let degree = interval * (i + angleOffsetInterval);
          return this.renderBtn(o, i, degree, outterDis, outterSize, center);
        })}
        {_.map(selectInnerOptions, (o, i) => {
          let degree = innerInterval * (i + angleOffsetInterval);
          return this.renderBtn(o, i, degree, innerDis, innerSize, center);
        })}
        {this.renderHandler(center)}
      </VStack>
    );
  }

  render(){
    let {size} = this.props;
    return (
      <VStack style={{width: size, height: size, alignItems: "center", justifyContent: "center"}}>
        {this.renderCore()}
      </VStack>
    );
  }

}

export default CyclePicker;
